export const black = '#000';
export const white = '#fff';
export const orange1 = '#ff7900';
export const orange2 = '#f16e00';

export const functionalGreen = '#32c832';
export const functionalRed = '#cd3c14';
export const functionalBlue = '#4294e5';
export const functionalYellow = '#ffcc00';

export const grey1 = '#333';
export const grey2 = '#666';
export const grey3 = '#999';
export const grey4 = '#ccc';
export const grey5 = '#ddd';
export const grey6 = '#eee';
